import Cookies from "js-cookie";
import { fetchuserContextFromAPI } from "./_fetchUserContextFromAPI";

export var setAuthHeaders = async function () {
  try {
    const response = await fetchuserContextFromAPI();
    if (Cookies.get("authHeaders")) {
    var cookie = Cookies.get("authHeaders")
      ? JSON.parse(Cookies.get("authHeaders"))
      : null;
    for (var header in cookie) {
        localStorage.setItem(header, encodeURIComponent(cookie[header]));
      }
      Cookies.remove("authHeaders");
    } else if (
      localStorage &&
      localStorage.getItem("WCToken") &&
      response?.activityToken?.activityId
    ) {
      localStorage.removeItem("WCToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("WCTrustedToken");
      localStorage.removeItem("personalizationID");
    }
  } catch (e) {
    console.log(e);
  }
};